import getApiClient from '@/plugins/api-client'

export default {
    loadCurrentData: function() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('privacy_policies/latest')
            .then((result) => {
                self.privacyPolicy = result.data['hydra:member'][0]
            })
            .catch(() => {})
    },

    updatePrivacyPolicy: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.post('privacy_policies', {
            content: self.privacyPolicy.content
        })
            .then((result) => {
                self.privacyPolicy = result.data
                self.success = true
            })
            .catch((error) => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }

            })
    },

    resetFormResult: function() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    }
}
